import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';

dayjs.extend(utc);
dayjs.extend(tz);

@Injectable({
  providedIn: 'root',
})
export class SetInterceptor implements HttpInterceptor {
  constructor(
    private translate: TranslateService,
    private _authService: AuthService,
    private _encryptionSerivce: EncryptionService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }

  handleRequest(req: HttpRequest<any>) {
    const storageKey = localStorage.getItem(environment.storageKey);
    const token: string | null = storageKey ? storageKey : null;
    let authReq: any;
    const headers = {
      'Content-Type': 'application/json',
      authorization: token ? `Bearer ${token}` : '',
      date: dayjs.default().valueOf().toString(),
    };
    if (
      req.url.includes('ServiceProvider/resetPassword') ||
      req.url.includes('ServiceProvider/requiredDocument')
    ) {
      this._authService.resetTokenSubject.subscribe((res: string) => {
        if (res || !localStorage.getItem('companyAccessToken')) {
          headers.authorization = res ? `Bearer ${res}` : `Bearer ${token}`;
        }
      });
    }

    authReq = req.clone({
      headers: new HttpHeaders({
        hash: this._encryptionSerivce.encryptHeaders(headers),
        deviceType: 'WEB',
      }),
    });

    if (
      req.method.toLowerCase() === 'post' ||
      req.method.toLowerCase() === 'put'
    ) {
      if (req.url.includes('Upload/uploadFiles')) {
        // Do nothing
      } else {
        // eslint-disable-next-line no-console
        console.log(req.body);
        authReq['body'] = {
          hash: this._encryptionSerivce.encryptionPayload(
            JSON.stringify(authReq.body)
          ),
        };
      }
    }
    return authReq;
  }
}
